export const CONSTANTS = {
    NEST_BACKEND_URL: "/api2/graphql",
    SAILS_BACKEND_URL: "/api",
}